exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.ef-lable[data-v-441eda51]::after {\r\n  border-bottom: 0 solid #ebedf0 !important;\n}\r\n", ""]);

// exports
